export interface MangaChapter {
  number: number;
  title: string;
  date: string;
}

export interface Manga {
  id: string;
  title: string;
  author: string;
  status: string;
  category: string;
  tags: string[];
  description: string;
  rating: number;
  views: number;
  coverImage: string;
  chapters: MangaChapter[];
  updateDate: string;
  isHot: boolean;
  isNew: boolean;
}

export const categories = [
  { slug: 'all', name: '全部', icon: 'ri-apps-line' },
  { slug: 'hot', name: '热门推荐', icon: 'ri-fire-line' },
  { slug: 'new', name: '最新上架', icon: 'ri-rocket-line' },
  { slug: 'romance', name: '恋爱', icon: 'ri-heart-line' },
  { slug: 'fantasy', name: '奇幻', icon: 'ri-magic-line' },
  { slug: 'action', name: '动作', icon: 'ri-sword-line' },
  { slug: 'thriller', name: '悬疑', icon: 'ri-search-eye-line' },
  { slug: 'comedy', name: '搞笑', icon: 'ri-emotion-laugh-line' },
  { slug: 'drama', name: '剧情', icon: 'ri-film-line' },
  { slug: 'historical', name: '古风', icon: 'ri-ancient-gate-line' },
  { slug: 'horror', name: '惊悚', icon: 'ri-ghost-line' },
];

export const mangaList: Manga[] = [
  {
    id: 'secretarys-escape',
    title: '秘书的逃脱',
    author: '朴智恩',
    status: '连载中',
    category: 'romance',
    tags: ['恋爱', '职场', '逆袭'],
    description: '在大企业担任秘书的韩智雅，每天忍受着苛刻上司的无理要求。某天意外获得了改变命运的机会，她决定精心策划一场完美的逃脱。然而在这场逃脱游戏中，她发现自己的内心也在悄然发生变化，对身边那个一直默默关注她的人产生了不一样的情愫。一个是想要逃离的牢笼，一个是渐渐沦陷的心动，智雅该如何抉择？',
    rating: 4.8,
    views: 2580000,
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20illustration%20of%20a%20beautiful%20woman%20in%20modern%20office%20attire%20with%20determined%20expression%2C%20soft%20warm%20lighting%2C%20clean%20minimalist%20background%2C%20elegant%20art%20style%2C%20digital%20painting%20with%20smooth%20lines%2C%20romantic%20drama%20theme%2C%20pastel%20color%20palette%2C%20Korean%20manhwa%20art%20style&width=600&height=800&seq=manga-cover-01&orientation=portrait',
    chapters: [
      { number: 1, title: '完美秘书的日常', date: '2026-07-20' },
      { number: 2, title: '无法忍受的一刻', date: '2026-07-22' },
      { number: 3, title: '计划开始', date: '2026-07-25' },
      { number: 4, title: '意外的相遇', date: '2026-07-28' },
      { number: 5, title: '心跳加速', date: '2026-08-01' },
      { number: 6, title: '两个人的秘密', date: '2026-08-03' },
    ],
    updateDate: '2026-08-03',
    isHot: true,
    isNew: false,
  },
  {
    id: 'demon-lord-awakening',
    title: '魔王觉醒',
    author: '李贤宇',
    status: '连载中',
    category: 'fantasy',
    tags: ['奇幻', '战斗', '异世界'],
    description: '平凡高中生金泰勋在一次意外事故中穿越到了剑与魔法的异世界，并发现自己体内隐藏着魔王的力量。在这个充满冒险和危险的奇幻世界中，他必须学会掌控自己的力量，结交伙伴，与黑暗势力展开一场关乎命运的决战。是成为毁灭世界的魔王，还是守护世界的英雄？一切由泰勋自己决定。',
    rating: 4.9,
    views: 4120000,
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20illustration%20of%20a%20young%20man%20with%20dark%20powerful%20aura%20surrounded%20by%20magical%20flames%2C%20fantasy%20theme%2C%20dramatic%20lighting%20with%20glowing%20red%20and%20purple%20magic%20effects%2C%20epic%20fantasy%20art%20style%2C%20clean%20background%2C%20dynamic%20pose%2C%20digital%20manhwa%20art&width=600&height=800&seq=manga-cover-02&orientation=portrait',
    chapters: [
      { number: 1, title: '平凡的一天', date: '2026-06-15' },
      { number: 2, title: '异世界', date: '2026-06-18' },
      { number: 3, title: '魔王之力', date: '2026-06-22' },
      { number: 4, title: '第一个伙伴', date: '2026-06-28' },
      { number: 5, title: '暗影来袭', date: '2026-07-05' },
      { number: 6, title: '决战前夜', date: '2026-07-15' },
      { number: 7, title: '觉醒时刻', date: '2026-07-25' },
      { number: 8, title: '新的征程', date: '2026-08-02' },
    ],
    updateDate: '2026-08-02',
    isHot: true,
    isNew: false,
  },
  {
    id: 'hidden-agenda',
    title: '暗流',
    author: '崔敏浩',
    status: '连载中',
    category: 'thriller',
    tags: ['悬疑', '犯罪', '心理'],
    description: '顶级律所的合伙人姜道允在一起看似普通的商业纠纷案件中，意外发现了一个横跨政商两界的惊天阴谋。随着调查的深入，身边的人开始一个接一个地遭遇不测。谁是真正的幕后黑手？而那个总是出现在案发现场的神秘女子的真实身份又是什么？',
    rating: 4.7,
    views: 1860000,
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20illustration%20of%20a%20man%20in%20a%20dark%20suit%20standing%20in%20shadow%2C%20mysterious%20atmosphere%2C%20noir%20style%2C%20rainy%20city%20background%20with%20neon%20reflections%2C%20thriller%20and%20crime%20theme%2C%20dark%20and%20moody%20color%20palette%2C%20cinematic%20lighting&width=600&height=800&seq=manga-cover-03&orientation=portrait',
    chapters: [
      { number: 1, title: '完美案件', date: '2026-07-10' },
      { number: 2, title: '疑点', date: '2026-07-14' },
      { number: 3, title: '暗藏的线索', date: '2026-07-18' },
      { number: 4, title: '第一个受害者', date: '2026-07-22' },
      { number: 5, title: '神秘女子', date: '2026-07-28' },
    ],
    updateDate: '2026-07-28',
    isHot: true,
    isNew: false,
  },
  {
    id: 'campus-laugh',
    title: '校园爆笑日记',
    author: '金秀雅',
    status: '连载中',
    category: 'comedy',
    tags: ['搞笑', '校园', '日常'],
    description: '转学到新学校的林小美本想安安静静度过高中生活，却被分到了一个全是奇葩的班级。中二病爆表的班长、沉迷cosplay的学霸、以及那个总是用冷笑话轰炸全班的历史老师。每一天都是一场啼笑皆非的校园喜剧，小美的吐槽功力也在与日俱增！',
    rating: 4.6,
    views: 3240000,
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20illustration%20of%20a%20cute%20high%20school%20girl%20with%20exaggerated%20funny%20expression%2C%20bright%20and%20colorful%20comedy%20theme%2C%20school%20uniform%2C%20chibi%20style%20influences%2C%20pastel%20and%20vibrant%20colors%2C%20playful%20and%20lighthearted%20mood%2C%20clean%20simple%20background&width=600&height=800&seq=manga-cover-04&orientation=portrait',
    chapters: [
      { number: 1, title: '转学第一天', date: '2026-06-20' },
      { number: 2, title: '奇葩同桌', date: '2026-06-23' },
      { number: 3, title: '中二病班长', date: '2026-06-27' },
      { number: 4, title: '体育课的灾难', date: '2026-07-01' },
      { number: 5, title: '学园祭准备', date: '2026-07-08' },
      { number: 6, title: '学园祭当天', date: '2026-07-15' },
      { number: 7, title: '期末考试地狱', date: '2026-07-25' },
    ],
    updateDate: '2026-07-25',
    isHot: false,
    isNew: true,
  },
  {
    id: 'blade-of-wind',
    title: '风之刃',
    author: '郑泰元',
    status: '连载中',
    category: 'action',
    tags: ['动作', '武侠', '热血'],
    description: '在江湖上销声匿迹三十年的风之刃传人尹辰，为了寻找失踪的师父重现江湖。一路上他遇到了一群志同道合的伙伴，共同对抗日益猖獗的黑暗势力。刀光剑影之间，一段尘封的过往也渐渐浮出水面。',
    rating: 4.8,
    views: 2900000,
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20illustration%20of%20a%20swordsman%20in%20traditional%20martial%20arts%20attire%2C%20holding%20a%20gleaming%20blade%2C%20dynamic%20action%20pose%2C%20wind%20and%20leaves%20swirling%20around%2C%20wuxia%20inspired%20aesthetic%2C%20dramatic%20contrast%20lighting%2C%20black%20and%20crimson%20accents%2C%20epic%20fight%20scene%20composition&width=600&height=800&seq=manga-cover-05&orientation=portrait',
    chapters: [
      { number: 1, title: '风起', date: '2026-06-10' },
      { number: 2, title: '初遇', date: '2026-06-15' },
      { number: 3, title: '黑夜中的战斗', date: '2026-06-20' },
      { number: 4, title: '伙伴集结', date: '2026-06-28' },
      { number: 5, title: '暗影山庄', date: '2026-07-05' },
      { number: 6, title: '血战', date: '2026-07-15' },
      { number: 7, title: '师父的踪迹', date: '2026-07-25' },
      { number: 8, title: '最终试炼', date: '2026-08-01' },
    ],
    updateDate: '2026-08-01',
    isHot: true,
    isNew: false,
  },
  {
    id: 'palace-intrigue',
    title: '宫中月',
    author: '文彩元',
    status: '连载中',
    category: 'historical',
    tags: ['古风', '宫廷', '权谋'],
    description: '朝鲜时代的深宫之中，一名身份卑微的宫女凭借过人的智慧和坚韧的意志，一步步走进权力的核心。然而在这华丽的宫墙之内，暗藏着无数杀机和阴谋。她能否在这步步惊心的后宫中保全自己，并获得真正的幸福？',
    rating: 4.7,
    views: 1750000,
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20illustration%20of%20a%20woman%20in%20traditional%20Korean%20hanbok%20standing%20in%20ancient%20palace%20courtyard%2C%20elegant%20historical%20romance%20theme%2C%20moonlight%20illuminating%20the%20scene%2C%20traditional%20Korean%20architecture%20background%2C%20soft%20warm%20color%20tones%2C%20refined%20and%20graceful%20art%20style%2C%20historical%20drama%20aesthetic&width=600&height=800&seq=manga-cover-06&orientation=portrait',
    chapters: [
      { number: 1, title: '入宫', date: '2026-07-01' },
      { number: 2, title: '后宫规矩', date: '2026-07-05' },
      { number: 3, title: '初次觐见', date: '2026-07-10' },
      { number: 4, title: '暗流涌动', date: '2026-07-18' },
      { number: 5, title: '意外发现', date: '2026-07-25' },
    ],
    updateDate: '2026-07-25',
    isHot: false,
    isNew: true,
  },
  {
    id: 'neon-seoul',
    title: '霓虹首尔',
    author: '尹智勋',
    status: '已完结',
    category: 'drama',
    tags: ['剧情', '都市', '成长'],
    description: '在首尔这座永不熄灯的城市里，五位来自不同背景的年轻人因缘际会相识相知。他们有的追逐梦想，有的为生存挣扎，有的迷失在繁华中。在霓虹灯光下，每个人都在书写着自己的人生故事，相互交织，共同成长。',
    rating: 4.5,
    views: 1450000,
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20illustration%20of%20young%20people%20walking%20in%20vibrant%20Seoul%20city%20street%20at%20night%2C%20neon%20signs%20reflecting%20on%20wet%20pavement%2C%20modern%20urban%20life%20theme%2C%20warm%20neon%20pink%20and%20cyan%20lighting%2C%20contemporary%20slice%20of%20life%20aesthetic%2C%20cinematic%20wide%20composition&width=600&height=800&seq=manga-cover-07&orientation=portrait',
    chapters: [
      { number: 1, title: '江南的夜晚', date: '2026-03-10' },
      { number: 2, title: '汉江边的约定', date: '2026-03-15' },
      { number: 3, title: '弘大邂逅', date: '2026-03-22' },
      { number: 4, title: '各自的烦恼', date: '2026-04-01' },
      { number: 5, title: '梨泰院之夜', date: '2026-04-10' },
      { number: 6, title: '选择的道路', date: '2026-04-20' },
      { number: 7, title: '再见首尔', date: '2026-05-01' },
    ],
    updateDate: '2026-05-01',
    isHot: false,
    isNew: false,
  },
  {
    id: 'ghost-dormitory',
    title: '幽灵宿舍',
    author: '韩志旼',
    status: '连载中',
    category: 'horror',
    tags: ['惊悚', '恐怖', '校园'],
    description: '深夜的大学宿舍楼里，总能听到奇怪的声音。303号房间曾经发生过一起离奇死亡事件，从那以后怪事频发。大一新生朴志浩被分配到了这间宿舍，从入住的第一夜开始，他就陷入了无法逃脱的恐怖旋涡之中。',
    rating: 4.4,
    views: 980000,
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20illustration%20of%20a%20dark%20dormitory%20hallway%20with%20a%20ghostly%20figure%20in%20the%20distance%2C%20horror%20atmosphere%2C%20dim%20flickering%20lights%2C%20cold%20blue%20and%20gray%20color%20palette%2C%20creepy%20and%20suspenseful%20mood%2C%20Korean%20horror%20comic%20style&width=600&height=800&seq=manga-cover-08&orientation=portrait',
    chapters: [
      { number: 1, title: '303号房间', date: '2026-07-05' },
      { number: 2, title: '第一夜', date: '2026-07-10' },
      { number: 3, title: '走廊的脚步声', date: '2026-07-16' },
      { number: 4, title: '镜中的脸', date: '2026-07-22' },
    ],
    updateDate: '2026-07-22',
    isHot: false,
    isNew: true,
  },
  {
    id: 'coffee-prince-remake',
    title: '咖啡王子一号店',
    author: '孙艺珍',
    status: '连载中',
    category: 'romance',
    tags: ['恋爱', '咖啡厅', '伪男'],
    description: '经济拮据的大学生崔恩秀为了生计，女扮男装进入了一家只招男生的高级咖啡店工作。在与帅气店长日复一日的相处中，她逐渐发现了店长不为人知的温柔一面。然而女扮男装的秘密总有被揭穿的一天……',
    rating: 4.8,
    views: 3650000,
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20illustration%20of%20a%20young%20woman%20in%20coffee%20shop%20uniform%20with%20short%20hair%20and%20boyish%20look%2C%20holding%20a%20cup%20of%20coffee%2C%20warm%20cozy%20cafe%20background%20with%20soft%20sunlight%2C%20romantic%20comedy%20theme%2C%20pastel%20warm%20tones%2C%20sweet%20and%20heartwarming%20mood&width=600&height=800&seq=manga-cover-09&orientation=portrait',
    chapters: [
      { number: 1, title: '求职大作战', date: '2026-07-01' },
      { number: 2, title: '变身', date: '2026-07-05' },
      { number: 3, title: '面试', date: '2026-07-08' },
      { number: 4, title: '第一天上班', date: '2026-07-12' },
      { number: 5, title: '深夜加班', date: '2026-07-18' },
      { number: 6, title: '心动瞬间', date: '2026-07-25' },
      { number: 7, title: '危机', date: '2026-08-02' },
    ],
    updateDate: '2026-08-02',
    isHot: true,
    isNew: false,
  },
  {
    id: 'dragon-realm',
    title: '龙域',
    author: '金泰亨',
    status: '连载中',
    category: 'fantasy',
    tags: ['奇幻', '冒险', '龙'],
    description: '在人类与龙族共存的世界中，少年龙骑士李真浩意外与一条被放逐的远古之龙签订了灵魂契约。他必须穿越五个龙域，收集失落的龙之碎片，阻止一场即将降临的灭世灾厄。在这段冒险旅程中，他将发现龙族背后隐藏了千年的秘密。',
    rating: 4.9,
    views: 4800000,
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20illustration%20of%20a%20young%20hero%20riding%20a%20massive%20dragon%20in%20the%20sky%2C%20epic%20fantasy%20adventure%20theme%2C%20dramatic%20sunset%20lighting%20with%20golden%20and%20crimson%20clouds%2C%20fantasy%20world%20landscape%2C%20dynamic%20and%20powerful%20composition%2C%20detailed%20dragon%20scales&width=600&height=800&seq=manga-cover-10&orientation=portrait',
    chapters: [
      { number: 1, title: '落龙之日', date: '2026-06-01' },
      { number: 2, title: '灵魂契约', date: '2026-06-05' },
      { number: 3, title: '火焰之域', date: '2026-06-12' },
      { number: 4, title: '冰霜之域', date: '2026-06-20' },
      { number: 5, title: '风暴之域', date: '2026-06-28' },
      { number: 6, title: '大地之域', date: '2026-07-08' },
      { number: 7, title: '暗影之域', date: '2026-07-20' },
      { number: 8, title: '最终之域', date: '2026-08-01' },
    ],
    updateDate: '2026-08-01',
    isHot: true,
    isNew: false,
  },
  {
    id: 'office-romance-101',
    title: '社内恋爱法则',
    author: '张娜拉',
    status: '连载中',
    category: 'romance',
    tags: ['恋爱', '职场', '办公室'],
    description: '游戏公司的新人策划师李智秀有一个秘密：她暗恋着同组的开发组长郑宇彬。她本想将这份心意深埋心底，却被公司的社内恋爱禁令搞得心神不宁。更糟糕的是，她发现郑宇彬对她似乎也有特别的感觉。在职场规则和真心之间，这段悄悄展开的恋情该何去何从？',
    rating: 4.6,
    views: 2200000,
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20illustration%20of%20a%20young%20woman%20and%20man%20in%20modern%20office%20setting%2C%20subtle%20romantic%20tension%2C%20office%20romance%20theme%2C%20clean%20professional%20background%20with%20computer%20screens%2C%20warm%20ambient%20lighting%2C%20soft%20pastel%20colors%2C%20Korean%20office%20romance%20aesthetic&width=600&height=800&seq=manga-cover-11&orientation=portrait',
    chapters: [
      { number: 1, title: '新人的秘密', date: '2026-07-01' },
      { number: 2, title: '禁恋条例', date: '2026-07-06' },
      { number: 3, title: '深夜加班', date: '2026-07-11' },
      { number: 4, title: '公司团建', date: '2026-07-18' },
      { number: 5, title: '两人的秘密', date: '2026-07-25' },
    ],
    updateDate: '2026-07-25',
    isHot: false,
    isNew: false,
  },
  {
    id: 'cooking-battle',
    title: '厨神争霸',
    author: '姜虎东',
    status: '连载中',
    category: 'action',
    tags: ['动作', '美食', '竞技'],
    description: '曾经被誉为天才料理少年的韩以俊，因为一次比赛事故失去了味觉。十年后，他隐姓埋名在一家小店当帮厨。直到有一天，全国最顶级的厨艺大赛在他所在的城市举办，命运的齿轮再次开始转动。',
    rating: 4.5,
    views: 1680000,
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20illustration%20of%20a%20young%20chef%20in%20white%20uniform%20holding%20a%20knife%20with%20focused%20expression%2C%20cooking%20battle%20theme%2C%20dramatic%20kitchen%20lighting%20with%20fire%20and%20steam%2C%20intense%20and%20competitive%20atmosphere%2C%20warm%20orange%20and%20amber%20tones%2C%20culinary%20action&width=600&height=800&seq=manga-cover-12&orientation=portrait',
    chapters: [
      { number: 1, title: '失去味觉的天才', date: '2026-06-20' },
      { number: 2, title: '十年后', date: '2026-06-25' },
      { number: 3, title: '比赛报名', date: '2026-07-01' },
      { number: 4, title: '预选赛', date: '2026-07-08' },
      { number: 5, title: '味觉的回归', date: '2026-07-18' },
    ],
    updateDate: '2026-07-18',
    isHot: false,
    isNew: false,
  },
  {
    id: 'time-loop-love',
    title: '时光循环中的告白',
    author: '刘智媛',
    status: '已完结',
    category: 'romance',
    tags: ['恋爱', '奇幻', '时空'],
    description: '大学生宋允儿意外获得了一本神秘的日记，每翻到最后一页就会回到过去的某个时间节点。她利用这个能力一次又一次地回到与初恋男友相识的那一天，试图改变两人最终分离的结局。然而她渐渐发现，改变过去需要付出的代价远比想象中更为沉重。',
    rating: 4.9,
    views: 5100000,
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20illustration%20of%20a%20woman%20holding%20an%20old%20journal%20with%20magical%20glowing%20effect%2C%20time%20travel%20romance%20theme%2C%20soft%20golden%20hour%20light%20streaming%20through%20window%2C%20nostalgic%20and%20bittersweet%20mood%2C%20delicate%20art%20style%2C%20warm%20sepia%20and%20rose%20tones&width=600&height=800&seq=manga-cover-13&orientation=portrait',
    chapters: [
      { number: 1, title: '神秘日记', date: '2026-04-01' },
      { number: 2, title: '第一次穿越', date: '2026-04-05' },
      { number: 3, title: '改变的瞬间', date: '2026-04-10' },
      { number: 4, title: '蝴蝶效应', date: '2026-04-15' },
      { number: 5, title: '最后的告白', date: '2026-04-20' },
      { number: 6, title: '正确的选择', date: '2026-04-28' },
    ],
    updateDate: '2026-04-28',
    isHot: false,
    isNew: false,
  },
  {
    id: 'detective-high',
    title: '侦探高中',
    author: '朴叙俊',
    status: '连载中',
    category: 'thriller',
    tags: ['悬疑', '推理', '校园'],
    description: '一所专门培养侦探的特殊高中里，五位天才少年组成了一支非官方侦探小队。从校园里的神秘失窃案开始，他们渐渐被卷入了一个又一个逼近真相的危险事件中。而学校暗藏的最大秘密，也将随着他们的调查慢慢被揭开。',
    rating: 4.5,
    views: 1350000,
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20illustration%20of%20five%20high%20school%20students%20in%20detective%20style%20outfits%2C%20mystery%20and%20investigation%20theme%2C%20school%20setting%20with%20magnifying%20glass%20and%20clues%2C%20dynamic%20group%20pose%2C%20suspenseful%20but%20youthful%20atmosphere%2C%20clean%20art%20style&width=600&height=800&seq=manga-cover-14&orientation=portrait',
    chapters: [
      { number: 1, title: '侦探学校的日常', date: '2026-07-05' },
      { number: 2, title: '失窃的考卷', date: '2026-07-10' },
      { number: 3, title: '五人小队成立', date: '2026-07-16' },
      { number: 4, title: '迷宫事件', date: '2026-07-22' },
    ],
    updateDate: '2026-07-22',
    isHot: false,
    isNew: true,
  },
  {
    id: 'magic-academy',
    title: '魔法学院特招生',
    author: '车银优',
    status: '连载中',
    category: 'fantasy',
    tags: ['奇幻', '魔法', '校园'],
    description: '完全没有魔法天赋的普通学生安智敏，阴差阳错地被全国最顶级的魔法学院录取了。在这个充满魔法和奇迹的地方，她凭借着过人的智慧和勇气，向所有人证明了有时候最强的魔法是知识和信念。',
    rating: 4.7,
    views: 3100000,
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20illustration%20of%20a%20girl%20in%20magical%20academy%20uniform%20with%20floating%20magic%20spells%20around%20her%2C%20fantasy%20school%20theme%2C%20bright%20and%20enchanting%20castle%20background%2C%20magical%20glowing%20effects%2C%20whimsical%20and%20hopeful%20atmosphere%2C%20starry%20night%20sky&width=600&height=800&seq=manga-cover-15&orientation=portrait',
    chapters: [
      { number: 1, title: '误发的录取通知', date: '2026-06-10' },
      { number: 2, title: '零魔力新生', date: '2026-06-14' },
      { number: 3, title: '第一堂课', date: '2026-06-18' },
      { number: 4, title: '隐藏的天赋', date: '2026-06-25' },
      { number: 5, title: '学院竞赛', date: '2026-07-02' },
      { number: 6, title: '暗黑魔法来袭', date: '2026-07-12' },
      { number: 7, title: '真正的力量', date: '2026-07-25' },
    ],
    updateDate: '2026-07-25',
    isHot: false,
    isNew: false,
  },
  {
    id: 'daily-life-of-villain',
    title: '反派大小姐的日常',
    author: '林允儿',
    status: '连载中',
    category: 'comedy',
    tags: ['搞笑', '穿越', '恶役'],
    description: '普通社畜沈雨薇一觉醒来发现自己穿越成了小说里的反派大小姐。按照原著剧情，她注定要在故事结尾被主角团打败。为了避免悲惨的结局，她决定改变剧情走向——然而无论怎么努力，事情总是朝着更搞笑的方向发展！',
    rating: 4.8,
    views: 3900000,
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20illustration%20of%20a%20beautiful%20villainess%20in%20elegant%20gothic%20dress%20with%20mischievous%20expression%2C%20comedy%20isekai%20theme%2C%20luxurious%20mansion%20background%2C%20playful%20and%20fun%20vibe%2C%20rich%20roses%20and%20candles%20decor%2C%20vibrant%20and%20warm%20color%20palette&width=600&height=800&seq=manga-cover-16&orientation=portrait',
    chapters: [
      { number: 1, title: '醒来变反派', date: '2026-06-15' },
      { number: 2, title: '改变命运的第一步', date: '2026-06-18' },
      { number: 3, title: '搞砸了', date: '2026-06-22' },
      { number: 4, title: '主角来了', date: '2026-06-28' },
      { number: 5, title: '意外的盟友', date: '2026-07-05' },
      { number: 6, title: '学园风波', date: '2026-07-12' },
      { number: 7, title: '命运的转折', date: '2026-07-22' },
      { number: 8, title: '新路线', date: '2026-08-01' },
    ],
    updateDate: '2026-08-01',
    isHot: true,
    isNew: false,
  },
];